/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * SideBar CSS
 */
export const styles = css`
 :host {
  
  top: 0;
  width: var(--nile-width-240px, var(--ng-spacing-296));
  display: flex;
  flex-direction: column;
  background-color: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary));
  height: 100%;
  overflow: hidden;  
  transition: width 0.25s ease, transform 0.25s ease;
  z-index: 1000;
}

 
:host([position='left']) {
  left: 0;
  border-right: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
}

:host([position='right']) {
  right: 0;
  border-left: 1px solid var(--nile-colors-neutral-400, var(--ng-colors-border-secondary));
}

 
:host([collapsed]) {
  width: var(--nile-width-70px, var(--ng-spacing-68));
}

 
:host([position='right'][collapsed]) {
  transform: translateX(calc(var(--sidebar-width) - var(--sidebar-collapsed-width)));
}

/*
 * Overlay mode: lift the sidebar out of normal flow so expanding it floats
 * on top of adjacent content instead of pushing siblings. Anchors to the
 * nearest positioned ancestor; set --sidebar-overlay-position: fixed to pin
 * it to the viewport instead.
 */
:host([overlay]) {
  position: var(--sidebar-overlay-position, absolute);
  top: 0;
  bottom: 0;
  height: 100%;
}

:host([overlay][position='left']) {
  left: 0;
}

:host([overlay][position='right']) {
  right: 0;
}

/* Elevate while expanded so it reads as floating above the page. */
:host([overlay]:not([collapsed])) {
  box-shadow: var(
    --sidebar-overlay-shadow,
    0px 8px 24px 0px rgba(119, 125, 130, 0.25)
  );
}

:host {
  scrollbar-width: thin;
  scrollbar-color: #64748b transparent;
}

:host::-webkit-scrollbar {
  width: 6px;
}
:host::-webkit-scrollbar-track {
  background: transparent;
}
:host::-webkit-scrollbar-thumb {
  background-color: #64748b;
  border-radius: 10px;
}

 
.scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

 
::slotted(nile-side-bar-header) {
  flex-shrink: 0;
}

::slotted(nile-side-bar-footer) {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  margin-top: auto;
}

 
 







`;

export default [styles];